import React from "react";
import { Card, Statistic, Row, Tooltip, Button } from "antd";
import PropTypes from "prop-types";
import { ExportOutlined, InfoCircleOutlined } from "@ant-design/icons";

const CardInfo = (props) => {
    const {info = null, onInfo = null, infoButtonText = null, goTo = null, goToInfo = ''} = props;
    return (
        <>
            <Card
                bodyStyle={{
                    ...props.style,
                   ...{boxSizing: 'border-box', overflow: 'visible', display: 'flex', flexDirection: 'column'}
                }}>
                <>
                    {
                        info && (
                            <Row justify="end" align="middle">
                                <Tooltip title={info}>
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </Row>
                        )
                    }
                    <Statistic
                        loading={props.loading}
                        title={props.title}
                        value={props.value}
                        valueStyle={props.size == 'medium' ? { fontSize: 17 } : {}}
                    />

                    {
                        goTo && (
                            <Row justify="end" align="middle">
                                <Tooltip title={goToInfo} onClick={goTo}>
                                    <ExportOutlined />
                                </Tooltip>
                            </Row>
                        )
                    }
                </>
                {
                    infoButtonText && (
                        <Row justify="center" align="middle" style={{marginTop: 'auto'}}>
                            <Button onClick={onInfo} type="link" >{infoButtonText}</Button>
                        </Row>
                    )
                }
            </Card>

        </>
    );
};

CardInfo.defaultProps = {
    loading: false,
    title: "",
    value: "",
    size: "large",
    style: {}
};

CardInfo.propTypes = {
    loading: PropTypes.bool,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    size: PropTypes.string,
    style: PropTypes.object
};

export { CardInfo }
